import { render } from "./CustomerAccountQuery.vue?vue&type=template&id=633d4c64&scoped=true"
import script from "./CustomerAccountQuery.vue?vue&type=script&lang=js"
export * from "./CustomerAccountQuery.vue?vue&type=script&lang=js"

import "./CustomerAccountQuery.vue?vue&type=style&index=0&id=633d4c64&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-633d4c64"]])

export default __exports__